
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Breadcrumb extends Vue {
    private breadcrumblist: any = [];

    @Watch('$route', { immediate: true, deep: true })
    private getBreadcrumb() {
        this.breadcrumblist = this.$route.matched.reduce((breadcrumbs: any, route: any) => {
            return breadcrumbs.concat((route.meta.breadcrumb || []).reduce((a: any, b: any) => {
                return a.concat(b);
            }, []));
        }, []);
    }
}
